import { useEffect, useRef } from "react";
import useUserService from "../../../../auth/hooks/useUserService";
import useService from "../../../../injector/hooks/useService";
import { AuthService } from "../../../../auth/services/auth.service";
import { PlanChatSupportService } from "../../../../support/services/plan-chat-support.service";
declare var __WISEPOPS_SITE_ID__: string;
export function useWisepops() {

  const planChatSupportService = useService(PlanChatSupportService);
  const { user } = useUserService();
  const authService = useService(AuthService);
  const scriptLoadedRef = useRef(false);
  function loadWisepopsScript(siteId) {
    if (scriptLoadedRef.current) return;

    // Set up Wisepops global object
    window['WisePopsObject'] = 'wisepops';
    window['wisepops'] = window['wisepops'] || function () {
      (window['wisepops'].q = window['wisepops'].q || []).push(arguments);
    };
    window['wisepops'].l = Date.now();

    // Create and configure script element
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://loader.wisepops.com/get-loader.js?v=3&h=${siteId}`;


    // Insert script into DOM
    const existingScript = document.getElementsByTagName('script')[0];
    if (existingScript && existingScript.parentNode) {
      existingScript.parentNode.insertBefore(script, existingScript);
    } else {
      // Fallback: append to end of body tag
      document.body.appendChild(script);
    }

    scriptLoadedRef.current = true;
  }

  const setWisepopsProperties = (isFreeUser: boolean, isLoggedIn: boolean, options: any = {}) => {
    const customProperties = {
      isFreeUser: isFreeUser,
      isLoggedIn: isLoggedIn,
      userEmail: user.email,
      userName: user.name,
      teamName: user.teamName,
      role: user.role
    };
    try {
      (window as any).wisepops("properties", customProperties, options);
    } catch (error) {
      console.error('Failed to set Wisepops properties:', error);
    }
  };

  const initWisepops = (isFreeUser: boolean) => {
    if (typeof __WISEPOPS_SITE_ID__ !== 'undefined' && __WISEPOPS_SITE_ID__) {
      loadWisepopsScript(__WISEPOPS_SITE_ID__);
      setWisepopsProperties(isFreeUser, true, { temporary: true });
    }
  };

  authService.beforeLogoutSubject.subscribe(() => {
    setWisepopsProperties(false, false, { temporary: true });
  });



  useEffect(() => {
    if (user) {
      let sub;
      try {
        sub = planChatSupportService.currentPlan$.subscribe(plan => {
          if (plan) {
            initWisepops(plan.currentPlanTier === "FREE");
          }
        });
      } catch (error) {
        console.error('Failed to subscribe to currentPlan$:', error);
      }

      return () => {
        if (sub && sub.unsubscribe) {
          sub.unsubscribe();
        }
      };
    }
  }, [user]);
}